export default {"src":"/_next/static/media/backyard.1bc4eba5.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};